export const isDevelopment = () =>
  (process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV) === "development" ||
  (process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV) === "local";
